import {useState} from "react";
import styled from "@emotion/styled";
import {Popover, Tooltip} from "@blueprintjs/core";
import {NestedJobStop} from "../../../generated/graphql";
import StopInfo, {StopInfoMetadata} from "../../map/stop/StopInfo";
import {StopPinWrapper} from "./StopPin";
import StopDot from "./StopDot";

export type ClusterMarker = {
  lat: number;
  lng: number;
  driverId: number;
  stop: NestedJobStop;
  info: StopInfoMetadata;
  color: string;
};

export type ClusteredStopsPinProps = {
  lat: number;
  lng: number;
  markers: ClusterMarker[];
  newWindow?: Window;
  usePortal?: boolean;
};

export const ClusteredStopsPin = ({markers, newWindow, usePortal}: ClusteredStopsPinProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ClusteredStopsPinWrapper>
      <Popover
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        placement="top"
        usePortal={usePortal}
        portalContainer={newWindow?.document.body}
        content={
          <ClusterPopoverContent>
            {markers.map((m) => (
              <Tooltip
                key={m.info.key}
                content={<StopInfo info={m.info} stop={m.stop} color={m.color} />}
                placement="top"
                popoverClassName="marker-popover"
                usePortal={usePortal}
                portalContainer={newWindow?.document.body}
              >
                <StopPinWrapper data-testid="cluster-stop-icon" data-color={m.color}>
                  <StopDot color={m.color} />
                </StopPinWrapper>
              </Tooltip>
            ))}
          </ClusterPopoverContent>
        }
      >
        <Tooltip
          content="Click to see overlapping stops"
          placement="bottom"
          popoverClassName="marker-popover"
          usePortal={usePortal}
          portalContainer={newWindow?.document.body}
        >
          <ClusterBadge
            data-testid="cluster-badge"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(true);
            }}
          >
            {markers.length}
          </ClusterBadge>
        </Tooltip>
      </Popover>
    </ClusteredStopsPinWrapper>
  );
};

const ClusteredStopsPinWrapper = styled.div`
  transform: translate(-50%, -50%);
`;

const ClusterBadge = styled.div`
  width: 22px;
  height: 22px;
  background-color: black;
  border-radius: 50%;
  border: 1px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 11px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
`;

const ClusterPopoverContent = styled.div`
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 160px;
`;
